var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.DMAP_READY)?_c('div',{staticClass:"view-map dashboard"},[_c('div',{staticClass:"map-inner"},[_c('mapview',{attrs:{"markers":_vm.VENUE_MARKERS,"jumpTo":_vm.GET_JUMPER}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }